module.exports = __webpack_public_path__ + "img/shuiweig.ae6cb8d4.png";